//got the image from the following resource
// https://unsplash.com/photos/Ky9JHrdvb1o
import { Link } from "react-router-dom";
import styles from "./DescriptionSection.module.css";
import { tempToColor } from "../utils/helpers";
function DescriptionSection({ tempColor }) {
  return (
    <div
      style={{
        backgroundColor: `${tempToColor(tempColor)}`,
      }}
      className={styles["description-container"]}
    >
      <div className={styles["description-text-container"]}>
        <h1 className={styles["description-heading"]}>
          Access our location and weather services
        </h1>
        <p className={styles["description-paragraph"]}>
          Use our services to access features such as reverse-geocoding, current
          time weather reports, and weather forecasting for either the next 48
          hours or the next 8 days. Our services are very simple to use, simply
          click anywhe re on the map and gain access to all the information
          you'll need in a snap.
        </p>
        <button className={styles["description-link"]}>
          <Link
            style={{
              borderStyle: "none",
            }}
            to={"/dashboard"}
            className={styles["description-link"]}
          >
            Open Application
          </Link>
        </button>
      </div>
      <div className={styles["image-container"]}>
        <img
          className={styles["image"]}
          src={require("../images/landing-image.jpg")}
          alt="A laptop displaying map information"
        />
      </div>
    </div>
  );
}

export default DescriptionSection;
